import { cn } from "@/utils/cn";

/**
 * Frame around table + optional footer.
 * `min-w-0` lets flex parents shrink so the inner scroll wrapper can show horizontal scroll.
 * `overflow-hidden` keeps corner radius; horizontal scroll lives on the Table wrapper (`scrollX`).
 */
export const dataTableFrameClass =
  "min-w-0 overflow-hidden rounded-md border border-light-lila/40 bg-white";

/** Flush table (no card chrome) for pages that already provide page-level framing. */
export const dataTableUnframedClass = "min-w-0 overflow-hidden bg-white";

export function getDataTableFrameClassName(framed: boolean): string {
  return framed ? dataTableFrameClass : dataTableUnframedClass;
}

export const dataTableHeaderSectionClass =
  "[&_tr]:border-b [&_tr]:border-light-lila/40";

/**
 * Extra classes on `th` only — must NOT use flex (breaks `display: table-cell` / row layout).
 * Sort control layout lives inside header content (e.g. `DataTable.sortHeader`).
 */
export const dataTableHeadCellClass =
  "min-w-0 font-heading break-words";

export const dataTableBodyCellClass = cn("min-w-0 py-4 font-body");

export function getDataTableBodyRowClass(onRowClick?: boolean): string {
  return onRowClick ? "cursor-pointer" : "";
}

/** Removes last body row bottom border when a footer sits flush below (avoids double rule). */
export function getDataTableBodyClassName(
  pagination: boolean
): string | undefined {
  return pagination ? "[&_tr:last-child]:border-b-0" : undefined;
}

export const dataTableEmptyCellClass =
  "min-w-0 px-6 py-12 text-center text-sm font-semibold text-dark-invirtus align-middle";

/** Built-in footer row: PaginationBar (summary + atom controls). */
export const dataTableFooterPaginationClass =
  "mx-0 w-full max-w-none border-t px-6 py-4";
